/**
 * Pinecone injects route HTML without reliably executing inline <script> tags.
 * Wire the admin sign-in form after each navigation.
 */

function safeNextHref(raw) {
  try {
    let s = String(raw || '').trim();
    if (!s) return null;
    for (let i = 0; i < 10; i += 1) {
      const u = new URL(s, globalThis.location.origin);
      if (u.origin !== globalThis.location.origin) return null;
      const path = (u.pathname || '/').replace(/\/+$/, '') || '/';
      if (!path.startsWith('/admin')) return null;
      if (path === '/admin/login' || path === '/login') {
        const inner = u.searchParams.get('next');
        if (!inner) return null;
        s = String(inner).trim();
        continue;
      }
      return u.pathname + u.search + u.hash;
    }
    return null;
  } catch {
    return null;
  }
}

function applyAdminLoginPageQueryState() {
  const hintEl = document.getElementById('adminShellLoginHint');
  const form = document.getElementById('adminShellLoginForm');
  const profilePanel = document.getElementById('adminProfileCompletePanel');
  try {
    const params = new URL(globalThis.location.href).searchParams;
    const reason = params.get('reason');
    if (reason === 'role-missing' && hintEl) {
      hintEl.textContent =
        'Your saved sign-in was incomplete. Sign in again below (or clear site data for this host if it keeps happening).';
      hintEl.classList.remove('hidden');
    }
    if (params.get('completeProfile') === '1') {
      const token = String(params.get('token') || '').trim();
      if (token && profilePanel) {
        profilePanel.classList.remove('hidden');
        if (form) form.classList.add('hidden');
        try {
          globalThis.localStorage?.setItem('dartsos.admin.token', token);
        } catch {
          /* ignore */
        }
      }
    }
  } catch {
    /* ignore */
  }
}

function bindAdminLoginFormOnce() {
  const form = document.getElementById('adminShellLoginForm');
  if (!form || form.dataset.pdlBound === '1') return;
  form.dataset.pdlBound = '1';
  const errEl = document.getElementById('adminShellLoginErr');

  form.addEventListener('submit', (ev) => {
    ev.preventDefault();
    if (errEl) errEl.textContent = '';
    const email = String(document.getElementById('adminShellEmail')?.value || '').trim();
    const password = String(document.getElementById('adminShellPassword')?.value || '');
    const Auth = globalThis.AdminAuth;
    if (!Auth || typeof Auth.login !== 'function') {
      if (errEl) errEl.textContent = 'Sign-in helper not loaded.';
      return;
    }
    Auth.login(email, password)
      .then(() => {
        let next = null;
        try {
          next = safeNextHref(new URL(globalThis.location.href).searchParams.get('next'));
        } catch {
          next = null;
        }
        globalThis.location.href = next || '/admin/dashboard';
      })
      .catch((e) => {
        if (errEl) errEl.textContent = String(e?.message || 'login_failed');
      });
  });
}

function bindAdminProfileCompleteFormOnce() {
  const profileForm = document.getElementById('adminProfileCompleteForm');
  if (!profileForm || profileForm.dataset.pdlBound === '1') return;
  profileForm.dataset.pdlBound = '1';
  const profileErr = document.getElementById('adminProfileCompleteErr');

  profileForm.addEventListener('submit', (ev) => {
    ev.preventDefault();
    if (profileErr) profileErr.textContent = '';
    let token = '';
    try {
      token = String(new URL(globalThis.location.href).searchParams.get('token') || '').trim();
      if (!token) token = globalThis.localStorage?.getItem('dartsos.admin.token') || '';
    } catch {
      token = '';
    }
    fetch('/api/auth/profile/complete', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({
        fullName: String(document.getElementById('pcFullName')?.value || '').trim(),
        nickname: String(document.getElementById('pcNickname')?.value || '').trim(),
        country: String(document.getElementById('pcCountry')?.value || 'GB').trim(),
      }),
    })
      .then((res) => res.json().then((data) => ({ res, data })))
      .then(({ res, data }) => {
        if (!res.ok) throw new Error(data.error || 'profile_complete_failed');
        globalThis.location.href = '/admin/dashboard';
      })
      .catch((e) => {
        if (profileErr) profileErr.textContent = String(e?.message || 'profile_complete_failed');
      });
  });
}

function bindAdminShellLoginOnce() {
  applyAdminLoginPageQueryState();
  bindAdminLoginFormOnce();
  bindAdminProfileCompleteFormOnce();
}

document.addEventListener('pinecone:after', () => {
  queueMicrotask(bindAdminShellLoginOnce);
});

queueMicrotask(bindAdminShellLoginOnce);
